import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inspectionUnlocked, setInspectionUnlocked] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("ssmch_session_token");
    setUser(null);
    setInspectionUnlocked(false);
  };

  const unlockInspection = async (pin) => {
    const { data } = await api.post("/auth/inspection-pin", { pin });
    setInspectionUnlocked(true);
    return data;
  };

  const lockInspection = () => setInspectionUnlocked(false);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, inspectionUnlocked, unlockInspection, lockInspection }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
